import BasePage from "../../../base/BasePage";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
// import { findObjectUseCase } from "../../../usecases/object";
import React from "react";
import TimeSheetTable from "./TimeSheetTable/TimeSheetTable";
import ManageTimeInOut from "../../../components/TimeManagement";
import TimeSheetPresenter from "./TimeSheetTable/TimeSheetPresenter";

class TimesheetPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new TimeSheetPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
      currentDate: new Date(),
      accessPass: false,
      dailyTime: [],
      buttonLabel: "TIME-IN",
      isDisable: false,
    };
    this.childRef = React.createRef();
  }

  // async componentDidMount() {
  //   await this.fetchDailyTimeRecord();
  // }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.dailyTime !== this.state.dailyTime) {
  //     this.updateButtonState();
  //   }
  // }

  getCurrentDate() {
    const now = new Date();
    const options = {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    return now.toLocaleDateString("en-US", options);
  }

  // async fetchDailyTimeRecord() {
  //   const employeeID = this.getCurrentUser().employee.id;
  //   const dailyTimeRecord = await findObjectUseCase().execute(
  //     "daily_time_record",
  //     {
  //       where: { date: this.getCurrentDate(), "employee.id": employeeID },
  //     }
  //   );
  //   this.setState({ dailyTime: dailyTimeRecord });
  // }
  // updateButtonState() {
  //   const { dailyTime } = this.state;
  //   let buttonLabel = "TIME-IN";
  //   let isDisable = false;

  //   if (dailyTime.length > 0) {
  //     if (
  //       dailyTime[0].timeOut === "--:--" &&
  //       dailyTime[0].timeAmOut === "--:--"
  //     ) {
  //       buttonLabel = "TIME-OUT";
  //     } else {
  //       buttonLabel = "You have already logged out";
  //       isDisable = true;
  //     }
  //   }

  //   this.setState({ buttonLabel, isDisable });
  // }

  handleAccessPass = (access) => {
    this.setState({ accessPass: access });
  };

  closeHandlePass = () => {
    this.setState({ accessPass: false });
  };

  handleDailyTimeUpdate = (data) => {
    this.setState({ dailyTime: data });
  };

  refetchData = () => {
    this.childRef.current.refetchData();
  };

  render() {
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Human Resource &gt;{" "}
              <span style={{ color: "#333" }}>Time Management</span>
            </p>
          </div>

          <ManageTimeInOut
            dailyTime={[]}
            refetchData={this.refetchData}
            buttonLabel={this.state.buttonLabel}
            isDisable={this.state.isDisable}
          />

          <TimeSheetTable
            ref={this.childRef}
            accessPass={this.handleAccessPass}
          />
        </div>
      </>
    );
  }
}

export default TimesheetPage;
